import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Icon, { IconsType } from 'components/Icon';
import Typography from 'components/Typography';
import { isMobile, isRtl } from 'helpers/device_helper';
import { system_closeSnackbar, system_openSnackbar } from 'store/system/actions';
import { UserDepositStatus } from '../MenuTopSection';
import { MobileKycBannerProps } from './MobileKycBanner.scheme';
import useStyles from './MobileKycBanner.styles';

const MobileKycBanner = ({ userFlowGuard, kycStatus, onNavigate }: MobileKycBannerProps) => {
    const classes = useStyles();
    const { t } = useTranslation('dashboard');
    const dispatch = useDispatch<any>();
    const history = useHistory();

    const requiresKycAction = userFlowGuard?.buttonType === UserDepositStatus.KYC;
    const shouldDisplayBanner = requiresKycAction && isMobile();
    if (!userFlowGuard || !shouldDisplayBanner) {
        return null;
    }

    const chevronIcon = isRtl() ? IconsType.chevron_left : IconsType.chevron_right;
    const targetLink = kycStatus?.link || userFlowGuard.link;

    const handleNavigate = () => {
        if (!targetLink) {
            dispatch(
                system_openSnackbar({
                    message: t('kyc_banner_error'),
                    severty: 'error',
                    onClose: () => dispatch(system_closeSnackbar()),
                })
            );
            return;
        }
        history.push(targetLink);
        onNavigate?.();
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        const isActivationKey = event.key === 'Enter' || event.key === ' ';
        if (isActivationKey) {
            event.preventDefault();
            handleNavigate();
        }
    };

    return (
        <div
            role="button"
            tabIndex={0}
            data-testid="mobile-kyc-banner"
            className={classes.wrapper}
            onClick={handleNavigate}
            onKeyDown={handleKeyDown}
        >
            <Icon className={classes.leadingIcon} name={IconsType.shield_tick} />
            <div className={classes.textBlock}>
                <Typography className={classes.title} variant="tSmallSemibold">
                    {t('kyc_banner_title')}
                </Typography>
                <Typography className={classes.subtitle} variant="tXsRegular">
                    {t('kyc_banner_subtitle')}
                </Typography>
            </div>
            <Icon className={classes.chevron} name={chevronIcon} />
        </div>
    );
};

export default MobileKycBanner;
